"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableComboChartDeprecated = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var sdk_ui_1 = require("@gooddata/sdk-ui");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var bucket_1 = require("../../../constants/bucket");
var uiConfig_1 = require("../../../constants/uiConfig");
var bucketConfig_1 = require("../../../utils/bucketConfig");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var sort_1 = require("../../../utils/sort");
var comboChartUiConfigHelperDeprecated_1 = require("../../../utils/uiConfigHelpers/comboChartUiConfigHelperDeprecated");
var UnsupportedConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/UnsupportedConfigurationPanel"));
var PluggableBaseChart_1 = require("../baseChart/PluggableBaseChart");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var without_1 = tslib_1.__importDefault(require("lodash/without"));
var PluggableComboChartDeprecated = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableComboChartDeprecated, _super);
    function PluggableComboChartDeprecated(props) {
        var _this = _super.call(this, props) || this;
        _this.type = sdk_ui_1.VisualizationTypes.COMBO;
        _this.supportedPropertiesList = [];
        _this.initializeProperties(props.visualizationProperties);
        return _this;
    }
    PluggableComboChartDeprecated.prototype.getExtendedReferencePoint = function (referencePoint) {
        var _a;
        var clonedReferencePoint = cloneDeep_1.default(referencePoint);
        var newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, clonedReferencePoint), { uiConfig: cloneDeep_1.default(uiConfig_1.COMBO_CHART_UICONFIG_DEPRECATED) });
        var buckets = (_a = clonedReferencePoint === null || clonedReferencePoint === void 0 ? void 0 : clonedReferencePoint.buckets) !== null && _a !== void 0 ? _a : [];
        var attributes = bucketHelper_1.getAllAttributeItemsWithPreference(buckets, [
            sdk_ui_1.BucketNames.TREND,
            sdk_ui_1.BucketNames.VIEW,
        ]).slice(0, 1);
        var measures = [];
        var secondaryMeasures = [];
        // ref. point has both my buckets -> reuse them fully
        if (bucketHelper_1.hasBucket(buckets, sdk_ui_1.BucketNames.MEASURES) && bucketHelper_1.hasBucket(buckets, sdk_ui_1.BucketNames.SECONDARY_MEASURES)) {
            measures = bucketHelper_1.getBucketItemsByType(buckets, sdk_ui_1.BucketNames.MEASURES, [bucket_1.METRIC]);
            secondaryMeasures = bucketHelper_1.getBucketItemsByType(buckets, sdk_ui_1.BucketNames.SECONDARY_MEASURES, [bucket_1.METRIC]);
            var restMeasures = bucketHelper_1.getBucketItemsWithExcludeByType(buckets, [sdk_ui_1.BucketNames.MEASURES, sdk_ui_1.BucketNames.SECONDARY_MEASURES], [bucket_1.METRIC]);
            secondaryMeasures = secondaryMeasures.concat(restMeasures);
        }
        else {
            // take all measures, first and its derived to primary, rest to secondary
            var allMeasures = bucketHelper_1.getAllItemsByType(buckets, [bucket_1.METRIC]);
            measures = bucketHelper_1.getFirstMasterWithDerived(allMeasures);
            secondaryMeasures = without_1.default.apply(void 0, tslib_1.__spreadArrays([allMeasures], measures));
        }
        set_1.default(newReferencePoint, bucket_1.BUCKETS, [
            {
                localIdentifier: sdk_ui_1.BucketNames.MEASURES,
                items: measures,
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.SECONDARY_MEASURES,
                items: secondaryMeasures,
            },
            {
                localIdentifier: sdk_ui_1.BucketNames.VIEW,
                items: attributes,
            },
        ]);
        newReferencePoint = comboChartUiConfigHelperDeprecated_1.setComboChartUiConfigDeprecated(newReferencePoint, this.intl, this.type);
        newReferencePoint = bucketConfig_1.configurePercent(newReferencePoint, false);
        newReferencePoint = bucketConfig_1.configureOverTimeComparison(newReferencePoint, !!this.featureFlags["enableWeekFilters"]);
        newReferencePoint = bucketHelper_1.applyUiConfig(newReferencePoint);
        newReferencePoint = sort_1.removeSort(newReferencePoint);
        return Promise.resolve(bucketHelper_1.sanitizeFilters(newReferencePoint));
    };
    PluggableComboChartDeprecated.prototype.renderConfigurationPanel = function () {
        var _a;
        if (document.querySelector(this.configPanelElement)) {
            var properties = (_a = this.visualizationProperties) !== null && _a !== void 0 ? _a : {};
            react_dom_1.render(react_1.default.createElement(UnsupportedConfigurationPanel_1.default, { locale: this.locale, pushData: this.pushData, properties: properties }), document.querySelector(this.configPanelElement));
        }
        return null;
    };
    return PluggableComboChartDeprecated;
}(PluggableBaseChart_1.PluggableBaseChart));
exports.PluggableComboChartDeprecated = PluggableComboChartDeprecated;
//# sourceMappingURL=PluggableComboChartDeprecated.js.map